document.addEventListener('DOMContentLoaded', function () {
  const currentHost = window.location.hostname;

  document.querySelectorAll('header a[href], .menu-drawer a[href]').forEach(function (link) {
    try {
      const linkUrl = new URL(link.href);

      if (linkUrl.hostname !== currentHost) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {}
  });
});